import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Styles from './Layout.scss';

export const Page = ({ className, children }) => (
  <section className={cn(Styles.page, className)}>
    {children}
  </section>
);
Page.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

export const PageBlock = ({ className, children }) => (
  <div className={cn(Styles.pageBlock, className)}>
    {children}
  </div>
);
PageBlock.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

export const PageBlockHeader = ({ className, isSeparated, children }) => {
  const classNames = cn(Styles.pageBlockHeader, className, {
    [Styles.separated]: isSeparated
  });
  return (
    <header className={classNames}>
      {children}
    </header>
  );
};
PageBlockHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  isSeparated: PropTypes.bool,
};

export const PageBlockContent = ({ className, children }) => (
  <div className={cn(Styles.pageBlockContent, className)}>
    {children}
  </div>
);
PageBlockContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

export const PageBlockCaption = ({ className, children }) => (
  <h3 className={cn(Styles.pageBlockCaption, className)}>
    {children}
  </h3>
);
PageBlockCaption.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};
